import UrlConstants from "../../navigation/UrlConstants";

export const onToSPressed = () => {
    window.open(UrlConstants.terms, '_blank');
}

export const onPrivacyPolicyPressed = () => {
    window.open(UrlConstants.privacy, '_blank');
}